module.exports = __webpack_public_path__ + "img/certificate.9cb0c873.svg";